import { render } from "./AdvanceFeatureTable.vue?vue&type=template&id=b2fd4622&scoped=true"
import script from "./AdvanceFeatureTable.vue?vue&type=script&lang=js"
export * from "./AdvanceFeatureTable.vue?vue&type=script&lang=js"

import "./AdvanceFeatureTable.vue?vue&type=style&index=0&id=b2fd4622&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2fd4622"]])

export default __exports__